var themeVars = require("app/theme/variables.js"),
    vars,
    interpolate;

module.exports = vars = {

    /**
     * The breakpoint that changes the layout from a page-like form factor to a
     * popup-like form factor.
     *
     * @returns  {number}  The min-width in pixels
     */
    getLayoutBreakpointPx: function() {
        return 768;
    },

    /**
     * The max width of the popup.
     *
     * @param    {string}  formFactor  The formfactor
     * @returns  {number}  The max width
     */
    getMaxPopupWidth: function(formFactor) {
        switch (formFactor) {
            case "narrow":
                return 768;
            case "wide":
            default:
                return 1280;
        }
    },

    /**
     * The padding above the thumbnail.
     *
     * @returns  {number}  The padding in pixels
     */
    getThumbnailAreaPaddingTopPx: function() {
        if (themeVars.windowWidth < vars.getLayoutBreakpointPx()) {
            return interpolate(16, 320, 32, 768);
        }
        else {
            return vars.getCloseButtonTopPx() + vars.getCloseButtonSizePx() / 2;
        }
    },

    /**
     * The padding below the thumbnail.
     *
     * @returns  {number}  The padding in pixels
     */
    getThumbnailAreaPaddingBottomPx: function() {
        return vars.getThumbnailAreaPaddingTopPx();
    },

    /**
     * The padding to the left of the thumbnail.
     *
     * @returns  {number}  The padding in pixels
     */
    getThumbnailAreaPaddingLeftPx: function() {
        return vars.getThumbnailAreaPaddingRightPx();
    },

    /**
     * The padding to the right of the thumbnail.
     *
     * @returns  {number}  The padding in pixels
     */
    getThumbnailAreaPaddingRightPx: function() {
        var paddingRight;

        // Page Layout
        if (themeVars.windowWidth < vars.getLayoutBreakpointPx()) {
            paddingRight = 0;
        }

        // Popup Layout
        else {
            paddingRight = Math.max(
                interpolate(24, 768, 48, 1280),
                vars.getCloseButtonSizePx() + vars.getCloseButtonRightPx() * 2
            );
        }

        return paddingRight;
    },

    /**
     * The offset of the close button from the top edge of the popup. This will
     * only be used in the popup form-factor.
     *
     * @returns  {number}  The offset in pixels
     */
    getCloseButtonTopPx: function() {
        return 24;
    },

    /**
     * The offset of the close button from the right edge of the popup. This
     * will only be used in the popup form-factor.
     *
     * @returns  {number}  The offset in pixels
     */
    getCloseButtonRightPx: function() {
        return 24;
    },

    /**
     * The size of the close button.
     *
     * @returns  {number}  The size in pixels
     */
    getCloseButtonSizePx: function() {
        return 32;
    },

    /**
     * The max width of the thumbnail.
     *
     * @param    {Object}  metrics  The layout metrics so far
     * @returns  {number}  The padding in pixels
     */
    getThumbnailMaxWidthPx: function(metrics) {
        var maxWidth;

        // Limit based on containerWidth
        maxWidth = Math.min(
            metrics.containerWidth
                - vars.getThumbnailAreaPaddingLeftPx()
                - vars.getThumbnailAreaPaddingRightPx(),
            640
        );

        return maxWidth;
    },

    /**
     * The maximum height of the thumbnail.
     *
     * @param    {Object}  metrics  The layout metrics so far
     * @returns  {number}  The maximum height in pixels
     */
    getThumbnailMaxHeightPx: function(metrics)  {
        var maxHeight;

        maxHeight = Math.max(
            240,
            metrics.popupHeight * 0.382,
            metrics.popupMaxHeight * 0.382
        );

        return maxHeight;
    },

    /**
     * The popup width at which we start showing a large bookmark button.
     *
     * @returns  {number}  The maximum height in pixels
     */
    getLargeBookmarkButtonMinSpacePx: function() {
        return 280;
    },

    /**
     * Whether to show captions on small action buttons.
     *
     * @returns {boolean} Whether to show captions
     */
    showSmallButtonCaptions: function() {
        // Mobile Layout
        if (themeVars.windowWidth < vars.getLayoutBreakpointPx()) {
            return false;
        }

        // Medium & Large Layouts
        else {
            return true;
        }
    },

    /**
     * The aspect ratio of the background.
     *
     * @param    {Object}  metrics  The layout metrics so far
     * @returns  {number}  The maximum height in pixels
     */
    getBackgroundHeightPx: function(metrics) {
        var height;

        // Page Layout
        height = (
            metrics.thumbnailHeight
                + metrics.thumbnailAreaPaddingTop
                + metrics.thumbnailAreaPaddingBottom
        ) * 1.618;

        return height;
    }
};

/**
 * Interpolates a value linearly between an output range based on a given input
 * range. Ensures that the current value is clamped within the input range to
 * avoid extrapolation.
 *
 * @param    {number}  outputMin        The minimum output value
 * @param    {number}  viewportMin      The minimum viewport width
 * @param    {number}  outputMax        The maximum output value
 * @param    {number}  viewportMax      The maximum viewport width
 * @returns  {number}  The interpolated value
 */
interpolate = function(outputMin, viewportMin, outputMax, viewportMax) {
    var currentViewport,
        clampedViewport,
        out;

    currentViewport = themeVars.windowWidth;

    clampedViewport = Math.min(
        Math.max(currentViewport, viewportMin),
        viewportMax
    );

    out = outputMin
        + (clampedViewport - viewportMin)
        * (outputMax - outputMin)
        / (viewportMax - viewportMin);

    return out;
};
